import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import ParticleBurst from "./ParticleBurst";

/* A dark glass block. When it scrolls into view the falling card "hits" it:
   gold burst at the impact corner + a small shake, and the content reveals. */
export default function GlassPanel({
  side = "right",
  impactCorner,
  className = "",
  children,
  testId,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.35 });
  const [revealed, setRevealed] = useState(false);
  const [shake, setShake] = useState(false);
  const [burst, setBurst] = useState(null);

  const corner =
    impactCorner || (side === "left" ? "top-right" : side === "center" ? "top-center" : "top-left");

  useEffect(() => {
    if (!inView || revealed) return;
    setRevealed(true);
    setShake(true);
    const el = ref.current;
    if (el) {
      const r = el.getBoundingClientRect();
      let x = r.left + 18;
      if (corner === "top-right") x = r.right - 18;
      if (corner === "top-center") x = r.left + r.width / 2;
      setBurst({ x, y: r.top + 8, key: Date.now() });
    }
    const t = setTimeout(() => setShake(false), 560);
    return () => clearTimeout(t);
  }, [inView, revealed, corner]);

  const justify =
    side === "left" ? "lg:justify-start" : side === "center" ? "lg:justify-center" : "lg:justify-end";

  return (
    <div className={`w-full flex justify-center ${justify}`}>
      <motion.div
        ref={ref}
        data-testid={testId}
        className={`glass ${shake ? "panel-shake" : ""} ${className}`}
        initial={{ opacity: 0, y: 30 }}
        animate={revealed ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
        transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
      >
        {children}
      </motion.div>
      {burst && <ParticleBurst key={burst.key} x={burst.x} y={burst.y} />}
    </div>
  );
}
